<template>
  <section class="app-promotion">
    <div class="app-promotion__header">
      <div class="app-promotion__copy">
        <h1 class="app-promotion__title">Save time!<br />Check-In Online</h1>
        <p class="app-promotion__lead">Plan a trip to your local Just Cuts salon at the tip of your fingers. With special access to wait time, quick online Check-In and rewards, your Just Cuts experience has just got even easier!</p>
        <h1 class="app-promotion__title">Unlock Your Just You<br />Loyalty Rewards today!</h1>
        <p class="app-promotion__lead">Download the Just Cuts app, sign up to 'Just You' in the Account menu, and start earning points today. Redeemable towards any Just Cuts service or JUSTICE Haircare product, earn 350 points and your $10 reward<sup>^</sup> will automatically be added to the app.</p>
      </div>
      <div class="app-promotion__media">
        <img class="app-promotion__image" role="presentation" src="https://extranet.justcuts.com.au//media/1080/ANZ2.40043.webp" alt="" />
      </div>
    </div>

    <div class="app-promotion__download">
      <div class="app-promotion__download-heading">
        <h2 class="app-promotion__download-title">Download today</h2>
      </div>
      <div class="app-promotion__download-badges">
        <a class="app-promotion__badge" href="https://play.google.com/store/apps/details?id=com.shift8.justcuts" target="_blank" rel="noopener">
          <img alt="Google Play" src="https://extranet.justcuts.com.au//media/210/GooglePlayBadge.14171.27282.jpg" width="160" />
        </a>
        <a class="app-promotion__badge" href="https://itunes.apple.com/au/app/just-cuts/id1296024711?mt=8" target="_blank" rel="noopener">
          <img alt="App Store" src="https://extranet.justcuts.com.au//media/210/AppStoreBadge.14172.27283.jpg" width="160" />
        </a>
      </div>
    </div>
  </section>
</template>


<script>

export default {

}
</script>
